import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useAdjustmentNoteLoaders } from "../../../../administration"
import { useFiscalDocumentLoaders } from "../../../../fiscal-documents"
import { useSaleOperationLoaders } from "../../../../sales"
import { useDeliveryService } from "../../../services/deliveryService"
import { CancelItemRow, NoteGenerationType } from "../../types"

export const useActions = () => {
    const saleOperationLoaders = useSaleOperationLoaders()
    const fiscalDocumentLoaders = useFiscalDocumentLoaders()
    const adjustmentNoteLoaders = useAdjustmentNoteLoaders()

    const { cancelDeliveryItems } = useDeliveryService()

    const { closeModal } = useUIActions()

    const submitCancellation = async (
        table: TableName,
        operationId: string,
        itemRows: CancelItemRow[],
        noteType: NoteGenerationType
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        try {
            await cancelDeliveryItems(table, operationId, itemRows, noteType)

            const { loadSaleOperation } = saleOperationLoaders()
            await loadSaleOperation(table, operationId, true)
            const { loadOperationFiscalDocuments } = fiscalDocumentLoaders()
            await loadOperationFiscalDocuments(operationId, false)
            const { loadOperationAdjustmentNotes } = adjustmentNoteLoaders()
            await loadOperationAdjustmentNotes(operationId, false)

            Emitter.emit(Event.DB_SUBMIT_DONE, true)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo generar la nota de crédito.')
        }
    }
    
    return {
        submitCancellation
    }
}
